import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const ReferralHistory = ({ client, history, onClose }) => {
  const filteredHistory = history.filter(item => 
    item.clientName === client.name
  );

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.referralHistoryModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>
            <FontAwesomeIcon icon="history" />
            <h3>Referral History - {client.name}</h3>
          </div>
          <button className={styles.modalCloseBtn} onClick={onClose}>
            <FontAwesomeIcon icon="times" />
          </button>
        </div>
        
        <div className={styles.modalContent}>
          <div className={styles.clientSummary}>
            <div className={styles.clientAvatar}>
              {client.name.charAt(0).toUpperCase()}
            </div>
            <div className={styles.clientDetails}>
              <h4>{client.name}</h4>
              <p>
                <FontAwesomeIcon icon="envelope" style={{ marginRight: '6px', opacity: 0.7 }} />
                {client.email}
              </p>
                      <div className={styles.clientStats}>
          <span>
            <FontAwesomeIcon icon="dollar-sign" style={{ marginRight: '4px' }} />
            Page Earned: ${client.totalSpent.toLocaleString()}
          </span>
          <span>
            <FontAwesomeIcon icon="money-bill-wave" style={{ marginRight: '4px' }} />
            Your Earnings: ${client.affiliateEarnings.toLocaleString()}
          </span>
        </div>
            </div>
          </div>
          
          <div className={styles.historySection}>
            <h4>
              <FontAwesomeIcon icon="receipt" style={{ marginRight: '8px' }} />
              Purchase History
            </h4>
            {filteredHistory.length > 0 ? (
              <div className={styles.historyList}>
                {filteredHistory.map((item) => (
                  <div key={item.id} className={styles.historyItem}>
                    <div className={styles.historyDate}>
                      <FontAwesomeIcon icon="calendar" style={{ marginRight: '6px', opacity: 0.7 }} />
                      {new Date(item.date).toLocaleDateString()}
                    </div>
                    <div className={styles.historyDetails}>
                      <div className={styles.purchaseAmount}>
                        <FontAwesomeIcon icon="dollar-sign" style={{ marginRight: '4px' }} />
                        ${item.purchaseAmount.toLocaleString()}
                      </div>
                      <div className={styles.commissionInfo}>
                        <span className={styles.commissionRate}>
                          <FontAwesomeIcon icon="percentage" style={{ marginRight: '4px' }} />
                          {item.affiliatePercentage}% commission
                        </span>
                        <span className={styles.commissionEarnings}>
                          <FontAwesomeIcon icon="plus" style={{ marginRight: '4px' }} />
                          ${item.earnings.toLocaleString()}
                        </span>
                      </div>
                    </div>
                    <div className={styles.historyStatus}>
                      <span className={`${styles.statusBadge} ${styles.statusCompleted}`}>
                        <FontAwesomeIcon icon="check-circle" />
                        {item.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.emptyHistory}>
                <FontAwesomeIcon icon="info-circle" />
                <p>No purchase history available for this client.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralHistory; 